import MuiDialogTitle from "@mui/material/DialogTitle";
import type React from "react";
export interface DialogTitleProps {
    className?: string;
    children: React.ReactNode;
}
export function DialogTitle({ className, children }: DialogTitleProps) {
    return <MuiDialogTitle className={className}>{children}</MuiDialogTitle>;
}
